import axios, { type AxiosError } from "axios";
import * as Sentry from "@sentry/react";

export const api = axios.create({
  baseURL: "https://api.vac.academy/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Storage unavailable or restricted
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      try {
        localStorage.removeItem("token");
      } catch {
        // ignore storage error
      }
    }

    try {
      Sentry.withScope((scope) => {
        scope.setTag("api_error", true);
        scope.setExtra("url", error.config?.url);
        scope.setExtra("method", error.config?.method);
        scope.setExtra("status", error.response?.status);
        scope.setExtra("responseData", error.response?.data);
        scope.setExtra("requestPayload", error.config?.data);
        Sentry.captureException(error);
      });
    } catch {
      // ignore Sentry reporting failure
    }

    return Promise.reject(error);
  }
);
